import { ReactNode } from 'react';
import { ButtonSize, ButtonType, ButtonVariant } from '../../types/button';

interface Props {
    children: ReactNode;
    onClick?: () => void;
    variant: ButtonVariant;
    type?: ButtonType;
    disabled?: boolean;
    size: ButtonSize;
    className?: string;
}

const Button = ({
                    disabled = false,
                    type = ButtonType.BUTTON,
                    onClick,
                    children,
                    variant,
                    size = ButtonSize.BASE,
                    className,
                }: Props) => {
    return (
        <button
            type={type}
            disabled={disabled}
            className={`px-4 py-1 transition ring-2 ring-offset-2 ring-transparent ring-offset-neutral-700 focus:outline-hidden enabled:cursor-pointer disabled:cursor-not-allowed  
                   ${size === ButtonSize.SMALL ? 'text-sm' : ''}
                   ${size === ButtonSize.BASE ? 'text-base' : ''}
                   ${size === ButtonSize.LARGE ? 'text-lg' : ''}
                   ${variant === ButtonVariant.PRIMARY
                ? `rounded-full bg-[#008DD2] disabled:opacity-40 enabled:hover:bg-[#007CC1]}`
                : ''
            }
                   ${variant === ButtonVariant.SECONDARY
                ? `text-sky-500 enabled:hover:text-[#007CC1] ring-0 ring-offset-transparent ring-transparent focus:ring-transparent`
                : ''
            }
                   ${variant === ButtonVariant.TERTIARY
                ? `rounded-full bg-neutral-800 enabled:hover:bg-neutral-900 text-neutral-200`
                : ''
            }
                   ${className}`}
            onClick={() => onClick ? onClick() : null}
        >
            {children}
        </button>
    );
};

export default Button;
